import React from 'react';
import PropTypes from 'prop-types';
import styles from './index.css';
import Chip from 'Chip';

import ConNav from './conNav';
import Banner from './banner';
import PrivacyList from './privacyList';

class Content extends React.PureComponent {
    // eslint-disable-next-line no-useless-constructor
    constructor() {
        super();
        this.conNavHeader = {
            navCenter: '管理团队',
            navRight: '凤凰新媒体',
        };
    }

    static propTypes = {
        content: PropTypes.object,
    };

    render() {
        const { content } = this.props;

        console.log(content);

        return (
            <div className={styles.pageBody}>
                <div className={styles.page}>
                    <div className={styles.pageHead}>
                        <div className={styles.pageEnd}>
                            <div className={styles.myContent}>
                                <Chip
                                    id="162635"
                                    type="static"
                                    title="首图banner"
                                    groupName="首图banner"
                                    content={content}>
                                    <Banner />
                                </Chip>
                                <ConNav conNavHeader={this.conNavHeader} />
                                <div className={styles.privacy}>
                                    <Chip
                                        id="162651"
                                        type="static"
                                        title="凤凰网平台个人信息保护政策"
                                        groupName="凤凰网平台个人信息保护政策"
                                        content={content}>
                                        <PrivacyList />
                                    </Chip>
                                </div>
                            </div>
                            <div className={styles.clear} />
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Content;
